import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_box_alt.svg'


const _hoisted_1 = { class: "bg-white flex flex-col flex-grow gap-2 rounded-xl" }
const _hoisted_2 = { class: "flex flex-col rounded-xl p-3 gap-3 pb-0" }
const _hoisted_3 = { class: "flex gap-2 font-semibold text-14px text-gray-lp-300 items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-6 max-w-none",
  alt: "box"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductPriceInsurance = _resolveComponent("ProductPriceInsurance")!
  const _component_WeightKoli = _resolveComponent("WeightKoli")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV3.shipment.detailItems.label")), 1)
      ])
    ]),
    _createVNode(_component_ProductPriceInsurance, {
      form: _ctx.formData,
      "onUpdate:form": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData = $event)),
      currentIndex: _ctx.errorIndex,
      "onUpdate:currentIndex": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errorIndex = $event)),
      formType: _ctx.formType,
      destination: _ctx.destination,
      isFirstRender: _ctx.isFirstRender,
      errorEstimationPrice: _ctx.errorEstimationPrice,
      listCodActive: _ctx.listCodActive,
      listDfodActive: _ctx.listDfodActive,
      goodsPriceIndex: _ctx.goodsPriceIndex,
      configGoodsPrice: _ctx.configGoodsPrice,
      configInsurance: _ctx.configInsurance,
      configCodAmount: _ctx.configCodAmount,
      insuranceData: _ctx.insuranceData,
      isRebookingFlow: _ctx.isRebookingFlow,
      onUpdateEstimationPrice: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('updateEstimationPrice'))),
      isEditSttMY: _ctx.isEditSttMY,
      isBookingShipment: _ctx.isBookingShipment,
      bookingType: _ctx.bookingType,
      schemaGoodsPriceType: _ctx.schemaGoodsPriceType,
      excludeEstimationValidation: _ctx.excludeEstimationValidation,
      insuranceBasic: _ctx.insuranceBasic,
      isRetail: _ctx.isRetail,
      isForceShowInsurance: _ctx.isForceShowInsurance,
      isEdit: _ctx.isEdit,
      onResetInsuranceType: _ctx.onResetInsurance,
      isCrossCountryRoute: _ctx.isCrossCountryRoute
    }, null, 8, ["form", "currentIndex", "formType", "destination", "isFirstRender", "errorEstimationPrice", "listCodActive", "listDfodActive", "goodsPriceIndex", "configGoodsPrice", "configInsurance", "configCodAmount", "insuranceData", "isRebookingFlow", "isEditSttMY", "isBookingShipment", "bookingType", "schemaGoodsPriceType", "excludeEstimationValidation", "insuranceBasic", "isRetail", "isForceShowInsurance", "isEdit", "onResetInsuranceType", "isCrossCountryRoute"]),
    _createVNode(_component_WeightKoli, {
      ref: "weightKoli",
      pieces: _ctx.totalPieces,
      "onUpdate:pieces": _cache[4] || (_cache[4] = ($event: any) => (_ctx.totalPieces = $event)),
      currentIndex: _ctx.errorIndex,
      "onUpdate:currentIndex": _cache[5] || (_cache[5] = ($event: any) => (_ctx.errorIndex = $event)),
      showWarningHwsProp: _ctx.showWarningHwsPropModel,
      "onUpdate:showWarningHwsProp": _cache[6] || (_cache[6] = ($event: any) => (_ctx.showWarningHwsPropModel = $event)),
      onUpdateGrossWeight: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('updateGrossWeight'))),
      form: _ctx.formData,
      isErrorHws: _ctx.isErrorHws,
      isCampaign: _ctx.isCampaign,
      errorEmbargo: _ctx.errorEmbargo,
      maxPieces: _ctx.maxPieces,
      isInterpackLanePending: _ctx.isInterpackLanePending,
      pieceIndex: _ctx.pieceIndex,
      configGrossWeight: _ctx.configGrossWeight,
      configDimension: _ctx.configDimension,
      configAdjustPiece: _ctx.configAdjustPiece,
      hwsMinimumData: _ctx.hwsMinimumData,
      tempPieces: _ctx.tempPieces,
      disabledWeight: _ctx.disabledWeight,
      disabledDimension: _ctx.disabledDimension,
      configAdjustPieceAdd: _ctx.configAdjustPieceAdd,
      configAdjustPieceRemove: _ctx.configAdjustPieceRemove,
      listKgDefault: _ctx.listKgDefault,
      isEditForm: _ctx.isEditForm,
      isShipment: _ctx.isShipment,
      dataRuleShipmentBooking: _ctx.dataRuleShipmentBooking,
      eligibleEditSize: _ctx.eligibleEditSize,
      isBookingShipment: _ctx.isBookingShipment,
      totalChargeableWeight: _ctx.totalChargeableWeight,
      disabledWeightAdjustment: _ctx.disabledWeightAdjustment
    }, null, 8, ["pieces", "currentIndex", "showWarningHwsProp", "form", "isErrorHws", "isCampaign", "errorEmbargo", "maxPieces", "isInterpackLanePending", "pieceIndex", "configGrossWeight", "configDimension", "configAdjustPiece", "hwsMinimumData", "tempPieces", "disabledWeight", "disabledDimension", "configAdjustPieceAdd", "configAdjustPieceRemove", "listKgDefault", "isEditForm", "isShipment", "dataRuleShipmentBooking", "eligibleEditSize", "isBookingShipment", "totalChargeableWeight", "disabledWeightAdjustment"])
  ]))
}